import styles from './IconText.module.css';

/**
 * Horizontal "icon + text" row for the flight brief PDF.
 * @param {object} props
 * @param {React.ReactNode} [props.icon] - Leading icon slot.
 * @param {React.ReactNode} props.children - Text content beside the icon.
 * @param {'sm' | 'md'} [props.size] - Icon dimensions.
 * @param {string} [props.textClassName] - Extra class names for the text slot.
 * @param {string} [props.className] - Extra class names for the row container.
 * @returns {JSX.Element}
 */
function IconText({
  icon = null,
  children,
  size = 'sm',
  textClassName = '',
  className = '',
}) {
  const iconSizeClass = styles[`icon-${size}`] ?? styles['icon-sm'];

  return (
    <div className={`${styles['text-icon']} ${className}`}>
      {icon ? <span className={`${styles.icon} ${iconSizeClass}`}>{icon}</span> : null}
      <span className={`${styles.text} ${textClassName}`}>{children}</span>
    </div>
  );
}

export default IconText;
